import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {result} from 'lodash';
import {ATTRIBUTES, datasetAttributePropType, INPUT_ACTIONS} from '../../../../../utils/query_utils';
import {
    inputFocusEvent,
    inputChangeEvent,
    inputSubmitEvent,
    inputCancelEvent, arrowDownEvent, arrowUpEvent,
} from '../../../../../services/query_builder_events';
import QueryBuilderInput from './query_builder_input';

export default class DatasetAttributeInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: this.getDefaultSearchQuery(),
        };

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.getAttrProp() !== this.getAttrProp(prevProps.attribute)) {
            this.setState({searchQuery: this.getDefaultSearchQuery()});
        }
    }

    getDefaultSearchQuery() {
        return result(this.getAttrProp(), this.props.valueProp, '');
    }

    getAttrProp(attribute = this.props.attribute) {
        const {propName} = this.props;
        if (propName) {
            return attribute[this.props.propName];
        }
        return attribute;
    }

    focusInput() {
        this.input.input.focus();
    }

    onFocus(input) {
        const {attribute, propName, menu} = this.props;
        inputFocusEvent.emit(input, menu, attribute, propName);
    }

    onBlur(input) {
        if (this.props.attribute.type === ATTRIBUTES.FILTER && this.props.propName === 'values' && this.state.searchQuery !== '') {
            this.onSubmit();
        }
    }

    onChange(searchQuery) {
        this.setState({searchQuery});
        inputChangeEvent.emit(searchQuery);
    }

    onSubmit() {
        inputSubmitEvent.emit(this.state.searchQuery);
    }

    onCancel() {
        this.setState({searchQuery: this.getDefaultSearchQuery()});
        inputCancelEvent.emit();
    }

    onKeyPress(key) {
        switch (key) {
            case INPUT_ACTIONS.ARROW_DOWN:
                arrowDownEvent.emit();
                break;
            case INPUT_ACTIONS.ARROW_UP:
                arrowUpEvent.emit();
                break;
            default:
                break;
        }
    }

    render() {
        const {menu, smallInput, placeholder, focusedPlaceholder, attribute, propName, display} = this.props;
        const {searchQuery} = this.state;
        return (
            <QueryBuilderInput
                value={searchQuery}
                display={display}
                smallInput={smallInput}
                className={`input-tag-${menu} ${this.getAttrProp() ? 'filled' : ''} input-tag-${attribute.type}`}
                placeholder={placeholder}
                focusedPlaceholder={focusedPlaceholder}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onChange={this.onChange}
                onSubmit={this.onSubmit}
                onCancel={this.onCancel}
                onKeyPress={this.onKeyPress}
                ref={(el) => { this.input = el; }}
                propName={propName}
            />
        );
    }
}

DatasetAttributeInput.propTypes = {
    attribute: datasetAttributePropType.isRequired,
    propName: PropTypes.string,
    valueProp: PropTypes.string.isRequired,
    menu: PropTypes.string.isRequired,
    smallInput: PropTypes.bool,
    display: PropTypes.element,
};

DatasetAttributeInput.defaultProps = {
    propName: null,
    smallInput: false,
};
